import ResetPasswordConfirmPage from "./ResetPasswordConfirmPage";

export default ResetPasswordConfirmPage;
